/**
 * Created by coolguy on 2018/8/30.
 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import intl from 'react-intl-universal';
import { isWeixinMobile, throttle } from '../../utils/util';
import { fixIosFocusProblem } from '../../utils/dom';
import { ThemeContext } from '../../store/ThemeProvider';
import ReactSVG from 'react-svg';

@inject('rootStore')
@observer
class BottomCommentSend extends React.Component {
  @observable value = '';
  @action setValue = e => {
    this.value = e.target.value;
  };
  submit = throttle(() => {
    const content = this.value;
    if (!content) {
      this.props.rootStore.uiStore.showAlert({
        content: intl.get('Please input the comment')
      });
      return;
    }
    if (content.length > 140) {
      this.props.rootStore.uiStore.showAlert({
        content: intl.get('Comment should not be longer than 140 letters')
      });
      return;
    }
    this.props.submit(content).then(
      action(() => {
        this.value = '';
      })
    );
  });
  toAddRedPack = () => {
    const { bottomCommentStore } = this.props.rootStore;
    bottomCommentStore.toggleMultiBottom();
  };
  blur = e => {
    console.log('on blur');
    fixIosFocusProblem(e.target);
  };

  focus = () => {
    console.log('on focus');
  };

  render() {
    const { use_package } = window.configDetail;
    return (
      <ThemeContext.Consumer data={this.value}>
        {theme => (
          <div
            className="bottom-send-comment-new"
            style={{ backgroundColor: theme.backgroundColor }}
          >
            <div className="input-wrapper">
              <input
                className="input"
                placeholder={intl.get('Say something') + '...'}
                value={this.value}
                onChange={this.setValue}
                onFocus={this.focus}
                onBlur={this.blur}
                style={{
                  backgroundColor: theme.componentColor,
                  color: theme.h1Color
                }}
              />
              {// 只有在微信手机浏览器上才需要展示这个按钮，毕竟PC上无法吊起支付
              use_package * 1 === 1 && isWeixinMobile() && (
                <div className="input-addon" onClick={this.toAddRedPack}>
                  <ReactSVG
                    src={require('../../svg/plus.svg')}
                    className="plus"
                    style={{ color: theme.h2Color }}
                  />
                </div>
              )}
            </div>

            <button
              className={'send-button'}
              onClick={this.submit}
              style={{
                backgroundColor: theme.mainColor,
                color: theme.componentColor
              }}
            >
              {intl.get('Send')}
            </button>
          </div>
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default BottomCommentSend;
